export type ModuleVisibility = {
  isSchedulingVisible: boolean;
};

export const ALL_MODULES_VISIBLE: ModuleVisibility = {
  isSchedulingVisible: true,
};

export const getModuleVisibility = (): ModuleVisibility => ALL_MODULES_VISIBLE;
export const useModuleVisibility = (): ModuleVisibility => ALL_MODULES_VISIBLE;
